import { Component, Input, TemplateRef } from '@angular/core';


/**
 * Renders a single cell of a list report: a column in {@link customColumns}
 * goes through the report's {@link customTemplate} (`{ row, col }` context),
 * every other column through <app-generic-table-cell>. On-screen only; the
 * emailed-reports HTML is produced by getDisplayText in models/report-columns.
 */
@Component({
  selector: 'app-report-cell',
  templateUrl: './report-cell.component.html',
  styleUrls: ['./report-cell.component.css'],
})
export class ReportCellComponent {
  // The column key being rendered.
  @Input() column: string;

  // The row model the cell belongs to. Passed to the generic cell's content
  // function and to the custom template's context.
  @Input() row: any;

  // Per-report function returning the plain export value for (row, column).
  // Only invoked for non-custom columns (the generic-cell fallback).
  @Input() getContentItem: (row: any, column: string) => string = () => '';

  // Columns whose markup is supplied by customTemplate rather than the generic
  // cell. Mirrors the report's ColumnsWithCustomHTML.
  @Input() customColumns: string[] = [];

  // Column-type groups forwarded to the generic cell for value formatting.
  @Input() objectIDColumns: string[] = [];
  @Input() currencyColumns: string[] = [];
  @Input() dateColumns: string[] = [];

  // Report-supplied template for custom columns; receives a { row, col }
  // context so its markup can reference the row (commonly aliased back to the
  // report's own loop variable name, e.g. `let-payment="row"`).
  @Input() customTemplate: TemplateRef<{ row: any; col: string }> | null = null;
}
